// src/app/views/pages_admin/exam_scores/rtAdExamScores.js
import Loadable from "app/components/Loadable";
import { lazy } from "react";
import { EXAM_TYPES } from "app/types/examTypes";

const ExamScores_Leet = Loadable(lazy(() => import("./ExamScores_Leet")));
const ExamScores_G5 = Loadable(lazy(() => import("./ExamScores_G5")));
const ExamScores_G7 = Loadable(lazy(() => import("./ExamScores_G7")));
const ExamScores_G72 = Loadable(lazy(() => import("./ExamScores_G72")));
const ExamScores_BAR = Loadable(lazy(() => import("./ExamScores_Bar")));

// Map exam type pathPrefix to corresponding component
const examComponentMap = {
  'leet': ExamScores_Leet,
  'g5': ExamScores_G5,
  'g7': ExamScores_G7,
  'g72': ExamScores_G72,
  'bar': ExamScores_BAR,
};

// Create routes with dynamic component selection based on pathPrefix
const routes = Object.values(EXAM_TYPES).map(examType => {
  // Get the appropriate component based on pathPrefix or default to ExamScores_G5
  const ExamComponent = examComponentMap[examType.pathPrefix] || ExamScores_G5;

  return {
    path: `${examType.pathPrefix}/exam-scores`,
    element: <ExamComponent examType={examType} />
  };
});

export default routes;